import React from 'react';
import {Grid, Typography} from '@mui/material';
import Dialog from 'components/Dialog';
import Panel from 'components/Panel';
import {Trans, useTranslation} from 'react-i18next';
import Button from 'components/Button';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useDispatch} from 'react-redux';

import {unpackId} from 'common/diplomatIdUtil';

import {useDeleteApi} from 'common/hooks/useDeleteApi';
import api from 'api';
import {layoutActions} from 'features/layout/redux';

type DeleteSftpUserDialogProps = {
   data: INav;
   onClose: () => void;
};

const DeleteSftpUserDialog = ({data, onClose}: DeleteSftpUserDialogProps) => {
   const {t} = useTranslation();

   const {id} = unpackId(data.id);

   const dispatch = useDispatch();
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      onClose();
   };
   const {request: onConfirm} = useDeleteApi(api.sftpUser + `/${id}`, {
      onSuccess,
   });

   return (
      <Dialog maxWidth="sm" header={t('Delete User')} close={onClose}>
         <Panel root>
            <Typography>
               <Trans t={t}>Do you really want to Delete User "{data.name}"?</Trans>
            </Typography>
         </Panel>
         <Grid container spacing={2} justifyContent={'center'}>
            <Grid item>
               <PrimaryButton onClick={() => onConfirm()}>{t('OK')}</PrimaryButton>
            </Grid>
            <Grid item>
               <Button onClick={onClose}>{t('Cancel')}</Button>
            </Grid>
         </Grid>
      </Dialog>
   );
};

export default DeleteSftpUserDialog;
